import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import HomePage from "@/pages/HomePage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
    return (
        <BrowserRouter>
            <div className="App relative">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contact" element={<HomePage initialScrollTarget="contact" />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
                <Toaster
                    position="bottom-center"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "rgba(20,20,20,0.96)",
                            color: "var(--text)",
                            border: "1px solid var(--line)",
                            backdropFilter: "blur(14px)",
                        },
                    }}
                />
            </div>
        </BrowserRouter>
    );
}

export default App;
